import React, { useEffect, useState } from 'react'

const Loading = ({ style }) => {

  return (
    <div style={style} class="loader"></div>
  )
}

export default Loading;
